var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 350,
    viewBox: "0 0 480 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 175,
    r: 174.545,
    fill: "#F9F5FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7272,
    cy: 44.091,
    r: 17.4545,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 275.364,
    r: 13.0909,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5455,
    cy: 301.545,
    r: 21.8182,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.182,
    cy: 100.818,
    r: 21.8182,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.727,
    cy: 24.4546,
    r: 15.2727,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_726_17450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.605 35.3638C211.09 35.3638 178.789 53.4077 159.132 81.0656C152.713 79.5518 146.019 78.7508 139.138 78.7508C91.2137 78.7508 52.3636 117.601 52.3636 165.525C52.3636 213.449 91.2137 252.299 139.138 252.299L139.211 252.299H355.954C355.993 252.299 356.033 252.299 356.073 252.299C398.006 252.299 432 218.305 432 176.372C432 134.438 398.006 100.444 356.073 100.444C353.094 100.444 350.156 100.616 347.267 100.95C330.645 62.3712 292.279 35.3638 247.605 35.3638Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.138,
    cy: 165.525,
    r: 86.774,
    fill: "url(#paint0_linear_726_17450)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.605,
    cy: 143.831,
    r: 108.468,
    fill: "url(#paint1_linear_726_17450)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.073,
    cy: 176.372,
    r: 75.9273,
    fill: "url(#paint2_linear_726_17450)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_726_17450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.909 244.818C178.909 211.079 206.26 183.727 240 183.727V183.727C273.74 183.727 301.091 211.079 301.091 244.818V244.818C301.091 278.558 273.74 305.909 240 305.909V305.909C206.26 305.909 178.909 278.558 178.909 244.818V244.818Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.909 267.727L254 258.818M260.364 243.546C260.364 255.495 250.677 265.182 238.727 265.182C226.778 265.182 217.091 255.495 217.091 243.546C217.091 231.596 226.778 221.909 238.727 221.909C250.677 221.909 260.364 231.596 260.364 243.546Z",
    stroke: "white",
    strokeWidth: 4.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_726_17450",
    x: 8.72728,
    y: 35.3638,
    width: 466.909,
    height: 304.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_726_17450"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.4545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_726_17450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_726_17450"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43.6364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.1818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_726_17450",
    result: "effect2_dropShadow_726_17450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_726_17450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_726_17450",
    x: 161.455,
    y: 166.273,
    width: 157.091,
    height: 157.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_726_17450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_726_17450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_726_17450",
    x1: 72.5076,
    y1: 108.192,
    x2: 225.912,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_726_17450",
    x1: 164.318,
    y1: 72.1652,
    x2: 356.073,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_726_17450",
    x1: 297.771,
    y1: 126.205,
    x2: 432,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.447711401ee65579f6d8fb76f073eec1.svg";
export { ForwardRef as ReactComponent };